"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fetchHelper = _interopRequireDefault(require("../../util/fetchHelper"));
var _environmentHelper = _interopRequireDefault(require("../../util/environmentHelper"));
var _returnUrlHelper = _interopRequireDefault(require("../../util/returnUrlHelper"));
var _store = _interopRequireDefault(require("../../redux/store"));
const updateAdyenPaymentDetails = async (paymentMethod, browserInfo, billingAddress) => {
  const API_URL = (0, _environmentHelper.default)();
  const url = "".concat(API_URL, "/connectors/adyen/payment-details");
  const {
    paymentMethods: {
      selectedPaymentMethod
    }
  } = _store.default.getState();
  const paymentMethodId = selectedPaymentMethod.id;
  try {
    const res = await (0, _fetchHelper.default)(url, {
      method: 'POST',
      body: JSON.stringify({
        paymentMethod,
        paymentMethodId,
        browserInfo,
        billingAddress,
        origin: window.location.origin,
        returnUrl: (0, _returnUrlHelper.default)({
          queryParams: {
            paymentMethodId
          },
          isMyAccount: true
        })
      })
    });
    return res.json();
  } catch (e) {
    return e;
  }
};
var _default = exports.default = updateAdyenPaymentDetails;